<template>
  <main>
    <div class="container mx-auto px-4 py-12 text-center">
      <h1 class="text-3xl font-semibold">{{ $t('contact_us') }}</h1>
      <p class="text-gray-800">{{ $t('milsped_group') }}</p>

      <div class="flex justify-between flex-wrap">
        <div class="flex text-center flex-col w-full md:w-1/3">
          <img
            class="self-center mb-4"
            src="/img/icons/contact_marker.png"
            alt="contact_marker image"
          />
          <p class="font-semibold">{{ $t('registered_office') }}</p>
          <p class="text-gray-800">
            Bulevar Arsenija Čarnojevića 59 V, 11070 Novi Beograd, Srbija
          </p>

          <p class="font-semibold mt-4">{{ $t('business_adress') }}</p>
          <p class="text-gray-800">
            Prva industrijska 14, 22314 Krnješevci,Stara Pazova, Srbija
          </p>
        </div>
        <div class="flex text-center flex-col w-full md:w-1/3">
          <img
            class="self-center mb-4"
            src="/img/icons/contact_person.png"
            alt="contact_person image"
          />
          <p class="font-semibold">{{ $t('Telephone') }}</p>
          <p class="text-gray-800">
            <a href="tel:+381112015100">+381(0) 11 20 15 100</a>
          </p>

          <p class="font-semibold mt-4">{{ $t('Fax') }}</p>
          <p class="text-gray-800">+381(0) 11 20 15 133</p>
        </div>
        <div class="flex text-center flex-col w-full md:w-1/3">
          <img
            class="self-center mb-4"
            src="/img/icons/contact_email.png"
            alt="contact_email image"
          />
          <p class="font-semibold">{{ $t('Email') }}</p>
          <p class="text-gray-800">
            <a href="mailto:office@milsped.com">office@milsped.com</a>
          </p>
        </div>
      </div>
    </div>
    <!-- <GmapMap
      :center="{ lat: 44.8802946, lng: 20.1395127 }"
      :zoom="15"
      :options="mapStyle"
      class="map"
    >
      <GmapMarker
        :position="{ lat: 44.8802946, lng: 20.1395127 }"
        :clickable="true"
        :icon="iconStyle"
      />
    </GmapMap> -->
    <div class="w-full">
      <!-- <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d250.19181376403174!2d20.425011646335157!3d44.809395956395825!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475a6ff5057b43a7%3A0xfa48d6c025d6e1d6!2sBulevar%20Arsenija%20%C4%8Carnojevi%C4%87a%2059%2C%20Beograd!5e0!3m2!1sen!2srs!4v1696583863136!5m2!1sen!2srs"
        height="450"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        class="w-full"
      ></iframe> -->
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11322.192411385284!2d20.4228568!3d44.8103974!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x262a95e0c7f98a41%3A0x20b65039a6c9368e!2sMil%C5%A1ped%20Group!5e0!3m2!1ssr!2srs!4v1713187699435!5m2!1ssr!2srs"
        height="450"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        class="w-full"
      ></iframe>
    </div>
    <div class="contact-form py-8 px-4">
      <div class="container mx-auto flex justify-center">
        <form class="w-full max-w-3xl">
          <div v-if="error" class="text-red-600 mb-3">
            {{ $t('contact_error') }}
          </div>
          <div class="flex flex-wrap -mx-3 mb-3">
            <div class="w-full md:w-1/2 px-3 mb-3 md:mb-0">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                for="grid-first-name"
                >{{ $t('name') }}*</label
              >
              <input
                v-model="name"
                :class="{ 'border-red-500': nameError }"
                class="appearance-none block w-full bg-gray-200 text-gray-700 border py-3 px-4 mb-2 leading-tight focus:outline-none focus:bg-white"
                type="text"
                placeholder="Jane"
              />
            </div>
            <div class="w-full md:w-1/2 px-3">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                for="grid-last-name"
                >{{ $t('surname') }}</label
              >
              <input
                v-model="surname"
                class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                type="text"
                placeholder="Doe"
              />
            </div>
          </div>
          <div class="flex flex-wrap -mx-3 mb-2">
            <div class="w-full md:w-1/2 px-3 mb-2 md:mb-0">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                >{{ $t('email') }}*</label
              >
              <input
                v-model="email"
                :class="{ 'border-red-500': emailError }"
                class="appearance-none block w-full bg-gray-200 text-gray-700 border py-3 px-4 mb-2 leading-tight focus:outline-none focus:bg-white"
                type="email"
                placeholder="mail@example.com"
              />
            </div>
            <div class="w-full md:w-1/2 px-3">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                >{{ $t('company') }}</label
              >
              <input
                v-model="company"
                :placeholder="$t('your_company_name')"
                class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                type="text"
              />
            </div>
            <div class="w-full px-3 mb-6 md:mb-0 mt-2">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                for="grid-state"
                >{{ $t('type_of_interest') }}</label
              >
              <div class="relative">
                <select
                  v-model="type"
                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                >
                  <option selected>{{ $t('quotation_request') }}</option>
                  <!-- <option>{{ $t('solutions') }}</option> -->
                  <option>{{ $t('payments') }}</option>
                  <option>{{ $t('career') }}</option>
                  <option>{{ $t('report_an_issue') }}</option>
                  <option>{{ $t('general') }}</option>
                </select>
                <div
                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                >
                  <svg
                    class="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="w-full px-3 mb-6 md:mb-0 mt-2">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                for="grid-state"
                >{{ $t('country') }}</label
              >
              <div class="relative">
                <select
                  v-model="country"
                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                >
                  <option>{{ $t('serbia') }}</option>
                  <option>{{ $t('monte_negro') }}</option>
                  <option>{{ $t('croatia') }}</option>
                  <option>{{ $t('slovania') }}</option>
                  <option>{{ $t('bosnia') }}</option>
                  <option>{{ $t('macedonia') }}</option>
                  <option>{{ $t('albania') }}</option>
                  <option>{{ $t('russia') }}</option>
                  <option>{{ $t('germany') }}</option>
                  <option>{{ $t('china') }}</option>
                  <option>{{ $t('usa') }}</option>
                </select>
                <div
                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                >
                  <svg
                    class="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="w-full px-3">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-2"
                >{{ $t('message') }}*</label
              >
              <textarea
                v-model="message"
                :class="{ 'border-red-500': messageError }"
                class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                name="message"
                col="40"
              ></textarea>
            </div>
            <div class="px-3 flex w-full justify-end">
              <button
                @click.prevent="sendMessage"
                class="self-end bg-blue-600 hover:bg-blue-700 px-12 uppercase hover:text-white mt-6 text-white px-5 py-3"
              >
                {{ $t('send') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
import { style } from '~/static/map_contact.js'

export default {
  data() {
    return {
      mapStyle: { styles: style },
      iconStyle: {
        url: '/img/icons/marker.png'
      },
      name: '',
      surname: '',
      company: '',
      message: '',
      email: '',
      country: '',
      type: 'Send request for quotation',
      emailError: false,
      nameError: false,
      messageError: false,
      error: false
    }
  },
  methods: {
    sendMessage() {
      this.error = false
      // eslint-disable-next-line no-console
      // console.log('Attemtping to send a message')
      const re = /\S+@\S+\.\S+/
      if (!re.test(this.email)) {
        this.emailError = true
        this.error = true
      } else {
        this.emailError = false
      }
      if (this.name === '') {
        this.nameError = true
        this.error = true
      } else {
        this.nameError = false
      }
      if (this.message === '') {
        this.messageError = true
        this.error = true
      } else {
        this.messageError = false
      }
      if (this.error) return

      const that = this
      const data = {
        service_id: 'service_z3xf1ai',
        template_id: 'template_ebux0ru',
        user_id: 'VDuiC4v8A5nx4p6OI',
        template_params: {
          name: this.name,
          email: this.email,
          surname: this.surname,
          company: this.company,
          message: this.message,
          type: this.type,
          country: this.country
        }
      }
      const allData = JSON.stringify(data)
      // eslint-disable-next-line no-console
      if (this.type === this.$t('quotation_request')) {
        // eslint-disable-next-line no-console
        // console.log('Quotation request!!')

        // used to be new URLSearchParams
        const webLeadData = JSON.stringify({
          oid: '00D09000007xwbs',
          first_name: this.name,
          last_name: this.surname,
          company: this.company,
          country: this.country,
          email: this.email,
          description: this.message,
          lead_source: 'Lead_Source_Portal',
          lead_source_2: 'Milšped Web Portal',
          technical_source: 'Web 2 Lead'
        })
        // '00N7Y000008hwPC': this.type,
        // '00N0900000IOM9y': 'Milšped Web Portal',
        // '00N0900000IOMA7': 'Web 2 Lead'

        // https://milsped.secure.force.com/services/apexrest/WebToLead
        // https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8
        fetch('https://milsped.secure.force.com/services/apexrest/WebToLead', {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'no-cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            // 'Content-Type': 'application/json'
            'Content-Type': 'application/json;charset=utf-8'
          },
          body: webLeadData // body data type must match "Content-Type" header
        }).then(res => {})
      }
      // eslint-disable-next-line no-unreachable
      this.$axios
        .$post('https://api.emailjs.com/api/v1.0/email/send', allData, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(function(response) {
          that.name = ''
          that.email = ''
          that.surname = ''
          that.company = ''
          that.message = ''

          // eslint-disable-next-line no-console
          const message =
            that.$i18n.locale === 'en'
              ? 'Message sent.'
              : 'Poruka je uspešno poslata.'
          alert(message)
        })
        .catch(function(error) {
          // eslint-disable-next-line no-console
          const message =
            that.$i18n.locale === 'en'
              ? 'Error. Message was not sent. Please try again later.'
              : 'Poruka nije uspešno poslata. Pokušajte ponovo kasnije.'
          alert(message)
          // eslint-disable-next-line no-console
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
img {
  height: 130px;
  width: 130px;
}
.map {
  max-width: 100vw;
  height: 350px;
}
</style>

img { height: 130px; width: 130px; } .map { max-width: 100vw; height: 350px; }
img { height: 130px; width: 130px; } .map { max-width: 100vw; height: 350px; }
